var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dataDeliveryMethods.length || _vm.dataExcludedMethods.length
    ? _c(
        "div",
        [
          _vm.dataDeliveryMethods.length
            ? _c(
                "h1",
                {
                  staticClass:
                    "subtitle has-text-weight-bold has-text-primary is-size-4"
                },
                [
                  _vm._v(
                    "\n        Opções de Envio (" +
                      _vm._s(_vm.dataDeliveryMethods.length) +
                      ")\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataDeliveryMethods.length
            ? _c("sc-table", {
                attrs: { data: _vm.dataDeliveryMethods },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "sc-table-column",
                          { attrs: { field: "logo", label: "", width: "120" } },
                          [
                            _c("figure", { staticClass: "image" }, [
                              _c("img", { attrs: { src: props.row.logo } })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "id", label: "#ID", width: "40" } },
                          [
                            _vm._v(
                              "\n        " + _vm._s(props.row.id) + "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: {
                              field: "metodo",
                              label: "Métodos de entrega"
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row.metodo) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "type", label: "Tipo" } },
                          [
                            _vm._v(
                              "\n        " + _vm._s(props.row.type) + "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "status", label: "Status" } },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row.status) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: { field: "estimate", label: "Frete exibido" }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm._f("currency")(
                                    props.row.final_shipping_cost
                                  )
                                ) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: {
                              field: "estimate",
                              label: "Prazo de entrega"
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row.estimate) +
                                " dias\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "cost", label: "Custo de envio" } },
                          [
                            _vm._v(
                              "\n        R$: " +
                                _vm._s(_vm._f("currency")(props.row.cost)) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          { attrs: { field: "", label: "" } },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "button is-primary",
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    props.row.getDetail(
                                      props.row.quoteFreight.id,
                                      props.row.delivery_method,
                                      props.row.fields,
                                      props.row.status,
                                      props.row.id
                                    )
                                  }
                                }
                              },
                              [_vm._v("\n          Cotação Detalhada")]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _vm.dataExcludedMethods.length
            ? _c(
                "h1",
                {
                  staticClass:
                    "subtitle has-text-weight-bold has-text-primary is-size-4"
                },
                [
                  _vm._v(
                    "\n        Opções nāo disponiveis (" +
                      _vm._s(_vm.dataExcludedMethods.length) +
                      ")\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.dataExcludedMethods.length
            ? _c("sc-table", {
                attrs: { data: _vm.dataExcludedMethods },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "sc-table-column",
                          { attrs: { field: "logo", label: "", width: "120" } },
                          [
                            _c("figure", { staticClass: "image" }, [
                              _c("img", { attrs: { src: props.row.logo } })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: {
                              field: "metodo",
                              label: "Métodos de entrega"
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row.metodo) +
                                "\n      "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "sc-table-column",
                          {
                            attrs: {
                              field: "motivo",
                              label: "Motivo",
                              centered: false
                            }
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(props.row.motivo) +
                                "\n      "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26e38de4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26e38de4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-quote-test-return/ScQuoteTestReturn.vue
// module id = null
// module chunks = 